import { Button } from "@/components/ui/button";
import { readCookie } from "@/utils/readCookie";
import { Link } from "react-router-dom";

const ClientHeader = () => {
  const user = readCookie("user");

  return (
    <header className="text-gray-600 body-font glass-header sticky top-0 z-20">
      <div className="container mx-auto flex p-5 flex-col md:flex-row justify-between items-center">
        <Link
          to={"/"}
          className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="w-10 h-10 text-white p-2 bg-indigo-500 rounded-full"
            viewBox="0 0 24 24"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
          <span className="ml-3 text-xl">Superloopz</span>
        </Link>
        {/* <nav className="md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center">
          <a className="mr-5 hover:text-gray-900">First Link</a>
          <a className="mr-5 hover:text-gray-900">Second Link</a>
          <a className="mr-5 hover:text-gray-900">Third Link</a>
          <a className="mr-5 hover:text-gray-900">Fourth Link</a>
        </nav> */}
        <div className="flex gap-2 items-center">
          {user?.abc === "client" ? (
            <Button className="bg-[#0595EB] hover:bg-[#0595EB]/90" asChild>
              <Link to={"/client/dashboard"}>Dashboard</Link>
            </Button>
          ) : (
            <>
              <Button className="bg-[#0595EB] hover:bg-[#0595EB]/90" asChild>
                <Link to={"/client/login"}>Login</Link>
              </Button>
              <Button variant="outline" asChild>
                <Link to={"/client/signup"}>Sign Up</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default ClientHeader;
